// extracted by mini-css-extract-plugin
export var blockedMessage = "_8g-3";
export var blockedOverlay = "_8g-1";
export var fadeIn = "_8g-2";
export var hereLink = "_8g-0";
export var slideUp = "_8g-4";